import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';

class SMReservationEditViewStatus extends React.Component {
  
  selectBoxDidChangeValue(e) {
    this.props.delegate.changeStatus(e.currentTarget.name, e.currentTarget.value);
  }
  
  render() {
    let statuses = [];
    let selectedValue = null;
    for (let i = 0; i < this.props.statuses.length; i++) {
      statuses.push(
        {value: this.props.statuses[i].status, label: this.props.statuses[i].status_text});

      if (this.props.reservation.status == this.props.statuses[i].status) {
        selectedValue = this.props.statuses[i].status;
      }
    }

    return (
      <td>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name='status'
              items={statuses}
              selectedValue={selectedValue}
              delegate={this}
              options={{className: 'w170'}} />
          </label>
        </span>
      </td>
    );
  }
}

SMReservationEditViewStatus.propTypes = {
  reservation: PropTypes.object.isRequired,
  statuses: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewStatus;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewStatus.jsx